import { render, staticRenderFns } from "./FinalizedList.vue?vue&type=template&id=19f9ba57&"
import script from "./FinalizedList.vue?vue&type=script&lang=js&"
export * from "./FinalizedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports